var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative texture-bg-css clearfix"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"page-header"},[_c('Breadcrumb')],1),_c('BasicData'),_c('Collections')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }